<template>
  <div class="inquiry_order_detail home_page">
    <el-header class="right-menu-name" height="40px">
      <el-breadcrumb separator="/" style="line-height:40px">
        <el-breadcrumb-item :to="{ name: 'basicInfo' }">个人中心</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <div class="order_content">
      <div class="order_address" v-if="info && info.sysUserAddressVo">
        <i class="el-icon-location"></i>
        <span class="address_name">{{info.sysUserAddressVo.receiveGoodsPerson}}</span>
        <span class="address_phone">{{info.sysUserAddressVo.receiveGoodsPhone}}</span>
        <span>{{info.sysUserAddressVo.orderAddress}}</span>
      </div>
      <!-- 商品列表 -->
      <el-table
        :data="info?info.payOrderItemVos.slice((goodsPage - 1) * 10, goodsPage * 10) : []"
        style="width: 100%"
        border
        ref="table">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column prop="goodsUrl" header-align="center" min-width="200" align="center" label="商品图片">
          <template slot-scope="scope">
            <img :src="scope.row.goodsUrl" alt="" width="150px">
          </template>
        </el-table-column>
        <el-table-column prop="goodsName" header-align="center" width="200" align="center" label="商品名称">
          <template slot-scope="scop">
            <div>{{scop.row.goodsName}}</div>
            <div>品牌：{{scop.row.brandName}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="goodsPrice" header-align="center" width="100" align="center" label="价格/货号">
          <template slot-scope="scop">
            <div>价格：{{(scop.row.tagPrice||0).toFixed(2)}}</div>
            <div>货号：{{scop.row.supplyCommodityCode}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="goodsModel" header-align="center" width="100" align="center" label="型号"></el-table-column>
        <el-table-column prop="goodsPrice" header-align="center" width="120" align="center" label="销售价格(元)">
          <template slot-scope="scop">
            {{(scop.row.goodsPrice||0).toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column prop="goodsNum" header-align="center" width="100" align="center" label="数量">
        </el-table-column>
        <el-table-column prop="goodsPriceDiscount" header-align="center" width="100" align="center" label="成交价(元)">
        </el-table-column>
        <el-table-column prop="money" header-align="center" width="90" align="center" label="小计">
        </el-table-column>
        <el-table-column prop="logisticsTemplate" header-align="center" width="100" align="center" label="运费模板">
          <template slot-scope="scope">
            {{scope.row.logisticsTemplate}}
            <span class="deliveryArea" v-show="scope.row.distribution===1">不在配送区域</span>
            <span class="deliveryArea" v-show="scope.row.distribution===3">面议</span>
          </template>
        </el-table-column>
        <el-table-column prop="expressFee" header-align="center" width="90" align="center" label="运费">
          <template slot-scope="scop">
            {{(scop.row.expressFee||0).toFixed(2)}}
          </template>
        </el-table-column>
      </el-table>
      <!-- 商品分页 -->
      <el-pagination :current-page="goodsPage"
                  :page-size="10"
                  v-if="info && info.payOrderItemVos && info.payOrderItemVos.length > 10"
                  :total="info.payOrderItemVos ? info.payOrderItemVos.length : 0"
                  layout="total, prev, pager, next, jumper"
                  @current-change="changeGoodsPage">
      </el-pagination>
      <!--  -->
      <el-row class="row-margin">
        <el-col :span="2">开票信息：</el-col>
        <el-col :offset="1" :span="8" v-if="info && info.payInvoiceInfoVo">
          <div class="invoice choosed">
            <div class="invoice_title">
              <div class="invoice_name ellipsis">{{info.payInvoiceInfoVo.companyName}}</div>
              <div class="invoice_type">{{info.payInvoiceInfoVo.invoiceType== '10' ? '普票' : '专票'}}</div>
            </div>
            <div class="invoice_info">
              <div class="invoice_lable">开户银行</div>
              <div class="invoice_value ellipsis">{{info.payInvoiceInfoVo.openingBank || '暂无'}}</div>
            </div>
            <div class="invoice_info">
              <div class="invoice_lable">银行账号</div>
              <div class="invoice_value ellipsis">{{info.payInvoiceInfoVo.bankAccountNo || '暂无'}}</div>
            </div>
            <div class="invoice_info">
              <div class="invoice_lable">企业地址</div>
              <div class="invoice_value ellipsis">{{info.payInvoiceInfoVo.companyAddress || '暂无'}}</div>
            </div>
            <div class="invoice_info">
              <div class="invoice_lable">企业税号</div>
              <div class="invoice_value ellipsis">{{info.payInvoiceInfoVo.taxpayerIdentity || '暂无'}}</div>
            </div>
          </div>
        </el-col>
        <el-col :offset="1" :span="10" v-if="info && fileList.length">
          <!-- 合同 -->
          <span class="download" @click="downloadFile(fileList[0].url)">{{fileList[0].name}}</span>
        </el-col>
      </el-row>
      <el-row class="row-margin">
        <el-col :span="2">订单备注：</el-col>
        <el-col :span="21" :offset="1">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            :disabled="true"
            :value="info?info.remark:''">
          </el-input>
        </el-col>
      </el-row>
      <!-- 待用户确认 -->
      <div class="row-margin row_but" v-show="info && info.inquiryStatus === '10'">
        <el-button class="but_plant" @click="changeStatusHandle('15')" :disabled="loading" :loading="loading">有意见并驳回</el-button>
        <el-button class="but_plant" type="primary" @click="changeStatusHandle('13')" :disabled="loading" :loading="loading">确认并提交订单</el-button>
      </div>
      <!-- 已确认 -->
      <div class="row-margin row_but text-center" v-show="info && info.inquiryStatus === '13'">
        <el-button class="but_plant" type="primary" @click="goOrderHandle()">查看订单</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'inquiryOrderDetail', // 询价订单详情
  data () {
    return {
      info: null,
      loading: false,
      fileList: [],
      goodsPage: 1
    }
  },
  computed: {
    id () {
      return this.$route.query.id
    }
  },
  mounted () {
    this.getInfo()
  },
  watch: {
    id (val) {
      this.getInfo()
    }
  },
  methods: {
    getInfo () {
      this.info = null
      this.fileList = []
      this.goodsPage = 1
      if (this.id) {
        this.$request.get(`/front/consumer/inquirysheet/selectInquiryOrderInfo/${this.id}`)
          .then(res => {
            this.info = res
            if (res && res.payOrderContractVo && res.payOrderContractVo.sysOssAliVos) {
              // this.fileList = [{
              //   name: res.payOrderContractVo.sysOssAliVos[0].fileName,
              //   url: res.payOrderContractVo.contractUrl
              // }]
              this.fileList = res.payOrderContractVo.sysOssAliVos.map(item => {
                return {
                  name: item.fileName,
                  url: item.baseUrl + '/' + item.objectName,
                  aliOssId: item.aliOssId
                }
              })
            }
          })
      }
    },
    changeGoodsPage (page) {
      this.goodsPage = page
    },
    // 修改状态
    changeStatusHandle (status = '15') {
      if (this.id) {
        if (this.loading) {
          return false
        }
        this.loading = true
        this.$http.post(`/front/consumer/inquirysheet/operationOrder`, {
          inquiryOrderId: this.id,
          inquiryStatus: status
        })
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            if (status === '15') {
              this.$message.success('驳回成功')
              // 驳回
              this.$router.go(-1)
            } else {
              this.$message.success('确认成功')
              // 13 成功
              this.getInfo()
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    // 下载合同
    downloadFile (url) {
      if (url) {
        window.open(url)
      }
    },
    goOrderHandle () {
      if (this.info && this.info.orderId) {
        this.$router.push({
          name: 'orderDetail',
          params: {
            id: this.info.orderId
          }
        })
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.inquiry_order_detail{
  .order_content{
    background-color: #fff;
    padding: 30px 50px;
    .order_address{
      line-height: 40px;
      font-size: 18px;
      margin-bottom: 30px;
      .address_name{
        margin-left: 10px;
        margin-right: 5px;
      }
      .address_phone{
        margin-right: 10px;
      }
    }
    .invoice{
      width: 100%;
      line-height: 30px;
      cursor: pointer;
      border: 1px solid #aaa;
      border-radius: 3px;
      padding: 10px;
      .invoice_title{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .invoice_type{
          padding-left: 5px;
          padding-right: 5px;
          flex-shrink: 0;
          color: #ffffff;
          background-color: #E02A21;
        }
      }
      .invoice_info{
        color: #666;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .invoice_lable{
          flex-shrink: 0;
          margin-right: 10px;
        }
        .invoice_value{
          flex-grow: 1;
          text-align: left;
        }
      }
    }
    .choosed{
      border: 1px solid #E02A21;
    }
    .deliveryArea{
      display: inline-block;
      border: 1px solid red;
      padding: 3px 5px;
      border-radius: 10px;
      color: red;
    }
    .row-margin{
      margin: 10px 0 10px;
    }
    .row_but{
      text-align: right;
      margin-top: 20px;
      .but_plant{
        min-width: 150px;
      }
    }
    .download{
      color: #2e88ff;
      cursor: pointer;
    }
  }
}
</style>
